import axios from 'axios'
import API_URL from '@/router/api'

export const getListSchool = (ctx, params) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.school.findMany

        axios.get(url, { params }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const create = (ctx, form) => {
    return new Promise((resolve, reject) => {

        axios.post(API_URL.school.create, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const update = (ctx, { id, form }) => {

    return new Promise((resolve, reject) => {

        const url = API_URL.school.update.replace(/__id__/, id)

        axios.put(url, form)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export const findBySchool = (ctx, id) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.school.findBySchool.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteSchool = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.school.delete.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const getSubjectLists = (ctx, { id }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.school.getSubjects.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const findSubjectLists = (ctx, params) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.findMany

        axios.get(url, { params }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const createSubjectList = (ctx, { form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.create

        axios.post(url, form).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteSubjectList = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.delete.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateSubjectList = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.update.replace(/__id__/, id)

        axios.put(url, form).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const findSubjectListAll = () => {

    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.findManyByList

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const findQuizCollection = (ctx, params) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.findMany

        axios.get(url, { params }).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteQuizCollection = (ctx, { id }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.delete.replace(/__id__/, id)

        axios.delete(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const createQuizCollection = (ctx, { form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.create

        axios.post(url, form).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const updateQuizCollection = (ctx, { id, form }) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.update.replace(/__id__/, id)

        axios.put(url, form).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const getQuizCollectionByIdList = (ctx, { id }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.getQuizCollectionByIdList.replace(/__id__/, id)

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const deleteQuizList = (ctx, { id, form }) => {

    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.deleteQuizList.replace(/__id__/, id)

        axios.put(url, form).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const findManyByQuizList = () => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.findManyByQuizList

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const getAvailableSchoolSubjects = () => {
    return new Promise((resolve, reject) => {
        const url = API_URL.school.getAvailableSubjects

        axios.get(url).then(res => {
            resolve(res)
        })
            .catch(err => {
                reject(err)
            })
    })
}

export const bulkAssignRevokeCollectionToSchool = (ctx, form) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.schoolQuizCollection.bulkAssignRevokeToSchool

        axios.post(url, form).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

export const bulkAssignRevokeSubjectToSchool = (ctx, form) => {
    return new Promise((resolve, reject) => {
        const url = API_URL.subjectList.bulkAssignRevokeToSchool

        axios.post(url, form).then(res => {
            resolve(res)
        })
        .catch(err => {
            reject(err)
        })
    })
}

